export const DEFAULT_DATE_PICKER_STATE = {
    stateSelectDayValue: '',
    stateSelectMonthValue: '',
    stateSelectYearValue: '',
    stateSelectDayOptions: [],
    stateSelectMonthOptions: [],
    stateSelectYearOptions: []
};
